import React from 'react';
import { Uppercase } from '../../commonLayouts/UppercaseFormat/Uppercase';
import './MsgModal.css';

const getMsgIconClass = (type) => {
    if (type === 'error') {
        return 'sf-error error-icon';
    }
    if (type === 'success') {
        return 'sf-check success-icon';
    }
    return 'sf-info info-icon';
};

const MsgModal = (props) => {
    return (
        <div className={`msg-modal ${props.type === 'error' ? 'border-error' : 'border-success'}`}>
            <p className='float-end mb-0'>
                <span className='sf-close pe-2 cursor text-neutral-900' onClick={props.onClick}></span>
            </p>
            <div className='media'>
                <span
                    className={`msg-icon float-start ms-2 ${getMsgIconClass(props.type)}`}></span>
                <div className='media-body text-neutral-900 ms-3'>
                    <p className='mt-0 font-b2 text-start font-medium mb-0 px-4 text-neutral-900'>
                        {props?.type ? Uppercase(props.type) : ''}
                    </p>
                    <p className='text-start font-b3 px-4 text-neutral-900'>{props.title}</p>
                </div>
            </div>
        </div>
    );
};

export default MsgModal;
